import { makeStyles } from 'tss-react/mui';

const useStylesTableRowGroupHeader: MaterialUIStylesCallback = makeStyles()((): MaterialUIStyles => ({
  tableRowGroupHeaderHidden: {
    '& th': {
      visibility: 'hidden',
      height: '0 !important',
      padding: '0 !important',
      border: '0 !important',
      '& > *': {
        display: 'none',
      },
    },
    '& td': {
      display: 'none',
    },
  },
  tableRowGroupHeaderSticky: {
    '& > th': {
      top: 35,
      zIndex: 15,
    },
  },
  tableRowGroupHeaderStickyEdit: {
    '& > th': {
      top: 52,
    },
  },
}));

export default useStylesTableRowGroupHeader;
